import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const CTA = ({
  eyebrow = "Get in touch",
  title = "Bring us a problem worth solving.",
  text = "Tell us what you are trying to change. We will respond within one business day with a clear next step — even if that step isn't us.",
}) => (
  <section className="cta-band">
    <div className="container">
      <div className="cta-inner">
        <div>
          <span className="eyebrow eyebrow--light">{eyebrow}</span>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="cta-actions">
          <Link to="/contact" className="btn btn--primary">
            Start a project <FiArrowRight />
          </Link>
          <Link to="/services" className="btn btn--ghost-light">
            Explore services
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default CTA;
